// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"b39964f7","160":"b39964f7","266":"b39964f7","684":"b39964f7","847":"b39964f7"}[chunkId] + ".chunk.css";
};